import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ItemsPage from './pages/ItemsPage';
import CakeDetailPage from './pages/CakeDetailPage';
import CustomOrderPage from './pages/CustomOrderPage';
import MyOrdersPage from './pages/MyOrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import CakeOrderPage from './pages/CakeOrderPage';
import WalletPage from './pages/WalletPage';
import './App.css';

export default function App() {
  return (
    <div className="mobile-frame">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/items/:categoryId/:categoryName" element={<ItemsPage />} />
          <Route path="/items/:categoryId" element={<ItemsPage />} />
          <Route path="/category/:categoryId/:categoryName?" element={<ItemsPage />} />
          <Route path="/cake/:categoryId/:cakeId" element={<CakeDetailPage />} />
          <Route path="/custom" element={<CustomOrderPage />} />
          <Route path="/cakeorder" element={<CakeOrderPage />} />
          <Route path="/myorders" element={<MyOrdersPage />} />
          <Route path="/order/:id" element={<OrderDetailPage />} />
          <Route path="/wallet" element={<WalletPage />} />
        </Routes>
      </Router>
    </div>
  );
}
